import { render, staticRenderFns } from "./DashboardTabs.vue?vue&type=template&id=47cff992"
import script from "./DashboardTabs.js?vue&type=script&lang=js&external"
export * from "./DashboardTabs.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports